import React from 'react';
import { Button, Modal } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';
import CreatableSelect from 'react-select/creatable';

import { Customer, Table } from 'services/action';
import { SkeletonsForm } from 'ui/components/skeleton';
import { Form, Select } from 'ui/components';

import _ from 'underscore';

const initialState = {
    isLoading: true,
    selectedEntities: null,
    name: '',
    company_name: '',
    address: '',
    pic_name: '',
    pic_phone: '',
    pic_email: '',
    finance_name: '',
    finance_phone: '',
    optionsEmails: [],
};

const entitiesOptions = [
  { value: 'community', label: 'Community' },
  { value: 'personal', label: 'Personal' },
  { value: 'corporate', label: 'Corporate' },
  { value: 'instansi', label: 'Instansi' },
];

const CustomerForm = ({ data, onClose, selected }) => {
    const Dispatch = useDispatch();
    const StateForm = useSelector((state) => state.Form);
    const StateTable = useSelector((state) => state?.Table?.data['customer']);

    const dummy = Array.from({ length: 5 }, (v, i) => i);

    const [
        {
            selectedEntities,
            name,
            company_name,
            address,
            pic_name,
            pic_phone,
            pic_email,
            optionsEmails,
            finance_name,
            finance_phone,
            isLoading,
        },
        setState,
    ] = React.useState(initialState);

    const $handleSubmit = async (c) => {
        let emails = []

        _.each(optionsEmails, (i) => {
        emails.push(i?.label)
        })

        const payload = {
            type: 'customer',
            entities: selectedEntities?.value || '',
            name,
            company_name,
            address,
            pic_name,
            pic_phone,
            pic_email,
            finance_emails: emails,
            finance_name,
            finance_phone,
        };

        if (data) {
            const submit = await Dispatch(Customer.$update(data?.id, payload));
            if (submit?.message === 'success') {
                onClose();
                Dispatch(Table.$reload('customer', StateTable));
            }
        } else {
            const submit = await Dispatch(Customer.$create(payload));
            if (submit?.message === 'success') {
                if (selected) {
                    onClose(submit?.data);
                } else {
                    onClose();
                    Dispatch(Table.$reload('customer', StateTable));
                }
            }
        }
    };

    React.useEffect(() => {
        setTimeout(() => {
            setState((prevState) => ({
                ...prevState,
                isLoading: false,
            }));
        }, 2000);
    }, []);

    React.useEffect(() => {
        if (!data) return;

        const entities =
            data?.entities === 'community'
                ? entitiesOptions[0]
                : data?.entities === 'personal'
                ? entitiesOptions[1]
                : data?.entities === 'corporate'
                ? entitiesOptions[2]
                : data?.entities === 'instansi'
                ? entitiesOptions[3]
                : null;

        let oe = []
        if (data?.finance_emails) {
            _.each(data?.finance_emails, (i) => {
                oe.push({label: i, value: i})
            })
        }

        setState((prevState) => ({
            ...prevState,
            selectedEntities: entities,
            name: data?.name,
            company_name: data?.company_name,
            address: data?.address,
            pic_name: data?.pic_name,
            pic_phone: data?.pic_phone,
            pic_email: data?.pic_email,
            finance_name: data?.finance_name,
            finance_phone: data?.finance_phone,
            optionsEmails: oe,
        }));
    }, [data]);

    if (isLoading) {
        return (
            <Modal.Body>
                <div className="row m-0">
                    {dummy?.map((d, i) => (
                        <div className="col-12" key={i}>
                            <SkeletonsForm count={1} />
                        </div>
                    ))}
                </div>
            </Modal.Body>
        );
    }

    return (
        <>
            <Modal.Body>
                <div className="row">
                    <div className="col-12">
                        <div className="mb-3">
                            <div className="">
                                <div className="mb-3">
                                    <label className='form-label required'>Entities</label>
                                    <Select
                                        isClearable
                                        classNamePrefix={
                                            StateForm?.errors?.pricing_schema ? 'is-invalid' : 'select'
                                        }
                                        placeholder=""
                                        value={selectedEntities}
                                        options={entitiesOptions}
                                        onChange={(e) =>
                                            setState((prevState) => ({
                                                ...prevState,
                                                selectedEntities: e,
                                            }))
                                        }
                                        error={StateForm?.errors?.entities}
                                    />

                                    {StateForm?.errors?.entities ? (
                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                        {StateForm?.errors?.entities}
                                        </div>
                                    ) : null}
                                </div>
                                <Form.Input
                                    required
                                    label="Nama Customer"
                                    type="text"
                                    value={name}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            name: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.name}
                                />
                                <Form.Input
                                    label="Nama Perusahaan"
                                    type="text"
                                    value={company_name}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            company_name: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.company_name}
                                />
                                <Form.Textbox
                                    label="Alamat Lengkap"
                                    rows={4}
                                    value={address}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            address: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.address}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="pt-2 mb-3">
                            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
                                Data Penanggung Jawab
                            </div>
                            <div className="pt-3">
                                <Form.Input
                                    required
                                    label="Nama Penanggung Jawab"
                                    type="text"
                                    value={pic_name}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            pic_name: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.pic_name}
                                />
                                <Form.Input
                                    required
                                    label="Nomor HP Penanggung Jawab"
                                    type="phone"
                                    value={pic_phone}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            pic_phone: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.pic_phone}
                                />
                                <Form.Input
                                    label="Email Penanggung Jawab"
                                    type="email"
                                    value={pic_email}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            pic_email: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.pic_email}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="pt-2 mb-3">
                            <div className="hr-text hr-text-left text-primary mb-3 mt-md-3 mt-3">
                                Data Finance
                            </div>

                            <div className="pt-3">
                                <Form.Input
                                    label="Nama Finance"
                                    type="text"
                                    value={finance_name}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            finance_name: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.finance_name}
                                />
                                <Form.Input
                                    label="Nomor HP Finance"
                                    type="phone"
                                    value={finance_phone}
                                    onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            finance_phone: e.target.value,
                                        }))
                                    }
                                    error={StateForm?.errors?.finance_phone}
                                />
                                <div className="mb-3">
                                    <label className='form-label'>Email Finance</label>
                                    <CreatableSelect
                                        value={optionsEmails}
                                        classNamePrefix={StateForm?.errors?.finance_emails ? 'is-invalid' : 'select'}
                                        placeholder="Enter Emails"
                                        style={{backgroundColor: 'rgba(42,255,0,0.3 )'}}
                                        className="bg-white"
                                        isMulti
                                        onChange={(e) =>
                                        setState((prevState) => ({
                                            ...prevState,
                                            optionsEmails: e,
                                        }))
                                        }
                                    />

                                    {StateForm?.errors?.finance_emails ? (
                                        <div className="invalid-feedback" style={{ display: 'block' }}>
                                        {StateForm?.errors?.finance_emails}
                                        </div>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <div className="row w-100">
                    <div className="col">
                        <Button
                            type="button"
                            className='btn btn-light w-100'
                            onClick={() => onClose()}
                        >
                            Batal
                        </Button>
                    </div>
                    <div className="col">
                        <Button
                            type="button"
                            className={cn(
                                StateForm?.loading ? 'btn-loading' : '',
                                'btn btn-primary w-100'
                            )}
                            disabled={StateForm?.loading}
                            onClick={$handleSubmit}
                        >
                            Simpan
                        </Button>
                    </div>
                </div>
            </Modal.Footer>
        </>
    );
};

export default CustomerForm;
